import { createAsyncThunk } from '@reduxjs/toolkit'
import includes from 'lodash/includes'
import { LivedataServerData, LockType } from '@lk/api'

import { ThunkApi } from '../index.d'
import { getSession, logout } from '../auth'
import { getUserID } from '../userConfig'
import { getLivedata } from './livedata.selectors'
import { loadUserConfigs } from '../userConfig'
import { TIMEOUT } from './livedata.constants'
import { delayedAction } from './livedata.helpers'
import { isUserLockedByOther } from './livedata.helpers'

export type LivedataPayload = LivedataServerData

export const loadLivedata = createAsyncThunk<LivedataPayload, void, ThunkApi>(
  '[LIVEDATA LOAD_LIVEDATA',
  async (_, { dispatch, getState, extra, rejectWithValue }) => {
    const { success, data } = await extra.api.livedata.get()

    if (success) {
      let curUserID = getUserID(getState())

      if (curUserID == null) {
        await dispatch(loadUserConfigs())
        curUserID = getUserID(getState())
      }

      // If current user is not Admin and locked by other user should be also logged out
      if (isUserLockedByOther(data, curUserID)) {
        dispatch(delayedAction(logout({ hard: true }), TIMEOUT / 2))
      }

      return data
    }

    return rejectWithValue('Failed to fetch livedata')
  },
)

const loadLivedataRec = () => async (dispatch, getState) => {
  let state = getState()

  const { isAuthed } = getSession(state)
  if (!isAuthed) {
    return
  }

  await dispatch(loadLivedata())

  state = getState()

  const curUserID = getUserID(state)

  const liveData = getLivedata(state)

  // stop future load iterations if user is locked because soon user will logout
  if (isUserLockedByOther(liveData, curUserID)) {
    return
  }

  dispatch(delayedAction(loadLivedataRec(), TIMEOUT))
}

export const repeatedlyLoadLivedata = () => delayedAction(loadLivedataRec(), TIMEOUT)
